import {createReducer, on} from "@ngrx/store";
import {Universe} from "../../models/Universe";
import * as UniverseActions from './universe.actions';
export const universeFeatureKey = 'universe';
export const universeInitialState: Universe | null = null;
export const universeReducer = createReducer<Universe | null>(
  universeInitialState,
  on(UniverseActions.update, (_state, { universe }) => universe),
);
